var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("home " + (_vm.isMini ? 'mini' : ''))},[_c('el-container',{staticClass:"el-container"},[(
        this.$store.state.user !== null &&
          this.$store.state.role !== null &&
            this.$store.state.role.indexOf(this.$VAR.ordinaryRole) === -1
      )?_c('el-aside',{staticClass:"el-aside"},[_c('Aside')],1):_vm._e(),_vm._v(" "),_c('el-container',{staticClass:"el-container"},[_c('el-header',{staticClass:"el-header"},[_c('Header')],1),_vm._v(" "),_c('el-main',{staticClass:"el-main"},[_c('router-view')],1),_vm._v(" "),(
          this.$store.state.role !== null &&
            this.$store.state.role.indexOf(this.$VAR.ordinaryRole) === -1
        )?_c('el-footer',{staticClass:"el-footer"},[_c('div',{staticClass:"footer"},[_c('span',[_vm._v("Copyright ©  "+_vm._s(new Date().getFullYear())+"    ")])])]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad11af9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/container/Home.vue
// module id = null
// module chunks = 